import { useState, useEffect, useCallback } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import Reader from './components/Reader';
import Gallery from './components/Gallery';
import Login from './components/Login';
import Header from './components/Header';
import GuestControl from './components/GuestControl';
import AlbumManager from './components/AlbumManager';
import SerieDetail from './components/SerieDetail';

function App()
{
  //? API
  const [albumsData, setAlbumsData] = useState([]);
  const [seriesData, setSeriesData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  //? Login
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [token, setToken] = useState(null);
  const [user, setUser] = useState(null);

  const fetchData = useCallback((endpoint) => 
    fetch(`${process.env.REACT_APP_API_URL}${endpoint}`, {
      headers: { 'Authorization': `Bearer ${token}` }
    }).then(res => res.json()), [token]);

  // ? Check for saved token and user in localStorage on component mount
  useEffect(() =>
  {
    const savedToken = localStorage.getItem('token');
    const savedUser = localStorage.getItem('user');
    if (savedToken && savedUser)
    {
      setToken(savedToken);
      setUser(JSON.parse(savedUser));
      setIsAuthenticated(true);
    } else
    {
      setLoading(false);
    }
  }, []);
  //? get albums from API if authenticated 

  useEffect(() =>
  {
    if (!isAuthenticated || !token) return;

    // Appel API pour récupérer les albums et series
    Promise.all([
      fetchData('/api/library/albums'),
      fetchData('/api/library/series')
    ])
    .then(([albums, series]) =>
    {
      setAlbumsData(albums);
      setSeriesData(series);
      setLoading(false);
    })
    .catch((error) =>
    {
      setError(error);
      setLoading(false);
    });
  }, [isAuthenticated, token, fetchData]);

  //? Handlers
  const handleLoginSuccess = (token, user) =>
  {
    setToken(token);
    setUser(user);
    setIsAuthenticated(true);
  };
  const handleLogout = () =>
  {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setToken(null);
    setUser(null);
    setIsAuthenticated(false);
  };

return (
  <BrowserRouter basename="/comics-reader">
    <div className="App">
      {!isAuthenticated ? (
        <Login onLoginSuccess={handleLoginSuccess} />
      ) : (
        <>
          <Header user={user} onLogout={handleLogout} />
          
          {loading && <p>Loading albums...</p>}
          
          {error && (
            <div className='errorDisplay'>
              <h3>⚠️ Error loading albums</h3>
              <p>{error.message}</p>
              <button onClick={() => window.location.reload()}>Retry</button>
            </div>
          )}
          
          {!loading && !error && (
            <Routes>
              <Route path="/" element={<Gallery albums={albumsData} series={seriesData} />} />

              <Route path="/serie/:serieSlug" element={
                <SerieDetail albums={albumsData} series={seriesData} />
              } />

              <Route path="/album/:slug" element={<Reader albums={albumsData} />} />
              
              <Route path="/admin/settings" element={
                user?.username === 'admin' ? <GuestControl /> : <Navigate to="/" />
              } />
              
              <Route path="/admin/albums" element={
                user?.username === 'admin' ? <AlbumManager /> : <Navigate to="/" />
              } />
            </Routes>
          )}
        </>
      )}
    </div>
  </BrowserRouter>
);
}

export default App;
